import { useMutation, useQueryClient } from "@tanstack/react-query"
import { profile } from "@shared/api/services"
import { toast } from "react-toastify"

export const useUpdateVideoPresentation = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: (data) => profile.updateVideoPresentation(data),
    onSuccess: () => {
      queryClient.invalidateQueries(['profile'])
			toast.success('Видео обновлено')
    },
		retry: 0
  })

	return mutation
}